/* globals $, Selectize, app, i18n, confirm, prompt, api */

// Selectize plugins

Selectize.define('silent_events', function() {

    'use strict';

    var self = this;

    this.addItem = (function() {

        return function(value, silent) {

            var events = silent ? [] : ['change'];

            var hash_key = function(value) {
                if (typeof value === 'undefined' || value === null) { return null; }
                if (typeof value === 'boolean') { return value ? '1' : '0'; }
                return value + '';
            };

            var debounce_events = function(self, types, fn) {
                var type;
                var trigger = self.trigger;
                var event_args = {};

                // override trigger method
                self.trigger = function() {
                    var type = arguments[0];
                    if (types.indexOf(type) !== -1) {
                        event_args[type] = arguments;
                    } else {
                        return trigger.apply(self, arguments);
                    }
                };

                // invoke provided function
                fn.apply(self, []);
                self.trigger = trigger;

                // trigger queued events
                for (type in event_args) {
                    if (event_args.hasOwnProperty(type)) {
                        trigger.apply(self, event_args[type]);
                    }
                }
            };

            debounce_events(this, events, function() {

                var $item, $option, $options;
                var self = this;
                var inputMode = self.settings.mode;
                var value_next, wasFull;
                value = hash_key(value);

                if (self.items.indexOf(value) !== -1) {
                    if (inputMode === 'single') { self.close(); }
                    return;
                }

                if (!self.options.hasOwnProperty(value)) { return; }
                if (inputMode === 'single') { self.clear(silent); }
                if (inputMode === 'multi' && self.isFull()) { return; }

                $item = $(self.render('item', self.options[value]));
                wasFull = self.isFull();
                self.items.splice(self.caretPos, 0, value);
                self.insertAtCaret($item);
                if (!self.isPending || (!wasFull && self.isFull())) {
                    self.refreshState();
                }

                if (self.isSetup) {
                    $options = self.$dropdown_content.find('[data-selectable]');

                    // update menu / remove the option (if this is not one item being added as part of series)
                    if (!self.isPending) {
                        $option = self.getOption(value);
                        value_next = self.getAdjacentOption($option, 1).attr('data-value');
                        self.refreshOptions(self.isFocused && inputMode !== 'single');
                        if (value_next) {
                            self.setActiveOption(self.getOption(value_next));
                        }
                    }

                    // hide the menu if the maximum number of items have been selected or no options are left
                    if (!$options.length || self.isFull()) {
                        self.close();
                    } else {
                        self.positionDropdown();
                    }

                    self.updatePlaceholder();
                    self.trigger('item_add', value, $item, silent);
                    self.updateOriginalInput({silent: silent});

                }

            });

        };

    })();

});

Selectize.define('query_cleanup', function() {

    'use strict';

    // Overrides the default search method to remove characters that lead to invalid queries like commas.

    var self = this;
    var search = self.search;

    this.search = (function() {

        return function(query) {

            query = query.replace(/,(?:\s+)?/, ' ');
            return search.apply(self, [query]);

        };

    })();

});

Selectize.define('deactivate_filter', function() {

    'use strict';

    // Do not filter out results based on input string.

    var self = this;

    this.getSearchOptions = (function() {

        return function() {

            var settings = self.settings;
            var sort = settings.sortField;
            if (typeof sort === 'string') {
                sort = [{field: sort}];
            }

            return {
                fields: settings.searchField,
                conjunction: settings.searchConjunction,
                sort: sort,
                filter: false
            };

        };

    })();

});

Selectize.define('clear_options', function() {

    'use strict';

    // Override the default clearOptions function so that selected items are not cleared.

    var self = this;

    this.clearOptions = (function() {

        return function() {

            self.loadedSearches = {};
            self.userOptions = {};
            self.renderCache = {};
            self.options = self.sifter.items = {};
            self.lastQuery = null;
            self.trigger('option_clear');

        };

    })();

});

Selectize.define('json_value', function() {

    'use strict';

    // Override getValue to return a JSON object for easier server side processing.

    var self = this;

    this.getValue = (function() {

        return function() {

            var value = {};

            self.items.forEach(function(item) {

                try {
                    item = JSON.parse(item);
                } catch(error) {
                    return;
                }

                if(value.hasOwnProperty(item.key)) {
                    value[item.key].push(item.value);
                } else {
                    value[item.key] = [item.value];
                }

            });

            if(Object.keys(value).length > 0) {
                value = JSON.stringify(value);
            } else {
                value = '';
            }

            return value;

        };

    })();

});

Selectize.define('attribute_search', function() {

    'use strict';

    // Override onSearchChange so that values are refreshed synchronously

    var self = this;

    this.onSearchChange = (function() {

        return function(value) {

            self.clearOptions();

            if (!value.length) {

                self.refreshOptions();
                return;

            }

            var columns = self.$input.data('columns'),
                items = [];

            Object.keys(columns).forEach( function(column) {

                items.push({
                    'value': JSON.stringify({ key: column, value: value }),
                    'label': columns[column] + ': ' + value,
                    'search': value
                });

            });

            self.addOption(items);
            self.refreshOptions();

        };

    })();

});

Selectize.define('address_attribute_search', function() {

    'use strict';

    // Override onSearchChange so that values are refreshed synchronously

    var self = this;

    this.onSearchChange = (function() {

        return function(value) {

            self.clearOptions();

            if (!value.length) {

                self.refreshOptions();
                return;

            }

            var columns = self.$input.data('columns'),
                usedColumns = [],
                items = self.items,
                options = [],
                item;

            // Make sure that each column is present only once

            for(var i = 0; i < items.length; i++) {

                item = JSON.parse(items[i]);

                usedColumns.push(item.key);

            }

            Object.keys(columns).forEach(function(column) {

                if(usedColumns.indexOf(column) !== -1) {
                    return;
                }

                options.push({
                    'value': JSON.stringify({ key: column, value: value }),
                    'label': columns[column] + ': ' + value,
                    'search': value
                });

            });

            self.addOption(options);
            self.refreshOptions();

        };

    })();

});

// Boxes

$(function() {

    'use strict';

    var body = $('body');

    var queryHandler = function(query, callback) {

        if (!query.length || query.length <= 2) { return callback(); }

        this.clearOptions();

        var parameters = { search: { name: query }  },
            source = this.$input.data('source');

        $.ajax({
            url: source,
            type: 'GET',
            dataType: 'json',
            data: parameters,
            error: function() {
                callback();
            },
            success: function(res) {
                callback(res);
            }
        });

    };

    var valueHandler = function() {

        var input = this.$input,
            silent = !input.hasClass('address-box'),
            values = input[0].dataset['value'],
            columns = input[0].dataset['columns'],
            options = [],
            items = [];

        if(!columns) {
            return;
        }

        columns = JSON.parse(columns);

        var updateOptions = function(i, value) {

            var jsonValue = JSON.stringify({ key: column, value: value });

            items.push(jsonValue);

            options.push({
                'value': jsonValue,
                'label': columns[column] + ': ' + value,
                'search': value
            });

        };

        if(!values) {
            return;
        }

        values = JSON.parse(values);

        for (var column in values) {

            if (!values.hasOwnProperty(column)) {
                continue;
            }

            $.each([].concat(values[column]), updateOptions);

        }

        this.clear(true);
        this.clearOptions();
        this.addOption(options);
        this.addItems(items, silent);

    };

    var updateResults = function(value, element, silent) {

        var item,
            parameters = { search: {} },
            source = this.$input.data('source');

        if(silent) {
            return;
        }

        if(this.items.length === 0) {
            return;
        }

        for(var i=0; i < this.items.length; i++) {

            item = JSON.parse(this.items[i]);
            parameters.search[item.key] = item.value;

        }

        $.ajax({
            url: source,
            type: 'GET',
            dataType: 'script',
            data: parameters,
            success: function() {

                var addresses = document.querySelectorAll('#addresses input[type=radio]');

                app.addEventListener(addresses, 'click', function() {
                    this.form.querySelector('.address-box-target').value = this.value;
                });

            }
        });

    };

    function initializeBoxes() {

        $('.selectized').each(function(_, element) {

            var selectize = element.selectize,
                selected = selectize.getValue();

            selectize.destroy();

            if(element.classList.contains('dropdown-box')) {
                element.value = selected;
            }

        });

        $('.selectize:visible').selectize();

        var searchBox = $('.search-box:visible').selectize({

            plugins: ['remove_button', 'attribute_search', 'clear_options', 'json_value'],
            valueField: 'value',
            labelField: 'label',
            searchField: 'search',
            create: false,
            persist: false,
            closeAfterSelect: true,
            highlight: false,
            selectOnTab: true,
            inputClass: 'form-control selectize-input',
            dropdownParent: 'body',
            onInitialize: valueHandler

        });

        if(searchBox[0] !== undefined && !window.Modal?.isVisible) {
            searchBox[0].selectize.focus();
        }

        $('.autocomplete-box:visible').selectize({

            plugins: ['query_cleanup', 'deactivate_filter'],
            valueField: 'id',
            labelField: 'value',
            searchField: 'value',
            options: [],
            create: function(input) {

                if(!confirm(i18n.t('master_data.confirm_creation', { name: input }))) {
                    return false;
                }

                var path = '/admin' + this.$input.data('source'),
                    resource = this.$input.data('resource'),
                    formData = new FormData();

                formData.append(resource + '[name]', input);

                if(resource === 'country') {

                    var iso_code = prompt(i18n.t('master_data.provide_iso_code', { name: input }));

                    if(iso_code === null) {
                        return false;
                    }

                    formData.append(resource + '[iso_code]', iso_code.toUpperCase());

                }

                api.post(path, formData, {
                    'Accept': 'text/javascript'
                });

                return { id: input, value: input };

            },
            persist: false,
            maxItems: 1,
            selectOnTab: true,
            load: queryHandler

        });

        $('.address-box:visible').selectize({

            plugins: ['silent_events', 'remove_button', 'address_attribute_search', 'clear_options', 'json_value'],
            valueField: 'value',
            labelField: 'label',
            searchField: 'search',
            create: false,
            persist: false,
            closeAfterSelect: true,
            highlight: false,
            maxItems: 2,
            selectOnTab: true,
            inputClass: 'form-control selectize-input',
            onInitialize: valueHandler,
            onItemAdd: updateResults,
            onItemRemove: updateResults

        });

        $('.dropdown-box:visible').selectize({
            create: false,
            highlight: false,
            inputClass: 'form-control selectize-input selectize-input-group'
        });

    }

    body.on('modal:added-layer', function() {
        initializeBoxes();
    });

    body.on('modal:removed-layer', function() {
        initializeBoxes();
    });

    $('.filter-reset').on('click', function(e) {

        var form;

        e.preventDefault();

        if (!confirm(i18n.t('messages.filters.reset'))) {
            return;
        }

        $('form.filter input, form.filter select, input.auto-submission').each(function(_, element) {

            element = $(element);

            if(element.attr('name') === 'utf8' || !element.val()) {
                return;
            }

            if(element.hasClass('selectized')) {
                element[0].selectize.clear(true);
            } else {
                element.val('');
                element.css('background-color', '');
            }

        });

        form = $(this).closest('form');

        form.submit();

        toggleFilters(form, true);

    });

    initializeBoxes();

});